


























import Vue from 'vue';
import { VueTelInput } from 'vue-tel-input';

interface PhoneValidationObject {
    e164?: string;
    number: {
        input: string;
        international: string;
        national: string;
        e164: string;
        rfc3966: string;
        significant: string;
    };
    regionCode: string;
    valid: boolean;
    possible: boolean;
    canBeInternationallyDialled: boolean;
    type:
        | 'fixed-line'
        | 'mobile'
        | 'fixed-line-or-mobile'
        | 'toll-free'
        | 'premium-rate'
        | 'shared-cost'
        | 'voip'
        | 'personal-number'
        | 'pager'
        | 'uan'
        | 'voicemail'
        | 'unknown';
    possibility: 'is-possible' | 'invalid-country-code' | 'too-short' | 'too-long' | string;
    isValid: boolean;
    country: {
        name: string;
        iso2: string;
        dialCode: string;
        priority: number;
        areaCodes: string[] | null;
    };
}

export default Vue.extend({
  name: 'PhoneInput',
  components: {
    VueTelInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Teléfono',
    },
    placeholder: {
      type: String,
      default: 'Ingrese su número de teléfono',
    },
    preferredCountries: {
      type: Array,
      default: () => ['AR', 'UY', 'CL', 'BR', 'PY'],
    },
    defaultCountry: {
      type: String,
      default: 'PY',
    },
    mode: {
      type: String,
      default: 'international',
    },
    maxlength: {
      type: Number,
      default: 25,
    },
    id: {
      type: String,
      default: 'phoneNumber',
    },
    name: {
      type: String,
      default: 'phoneNumber',
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: 'Número de teléfono inválido',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: true,
    };
  },
  computed: {
    inputOptions(): Record<string, unknown> {
      // @ts-ignore
      return {
        placeholder: this.placeholder,
        maxlength: this.maxlength,
        id: this.id,
        name: this.name,
      };
    },
  // ...existing code...
  },
  methods: {
    onPhoneInput(formattedNumber: string): void {
      // @ts-ignore
      this.$emit('input', formattedNumber);
    },
    onPhoneValidate(phoneObject: PhoneValidationObject): void {
      // @ts-ignore
      this.isValid = phoneObject?.isValid ?? false;
      // @ts-ignore
      this.$emit('validate', phoneObject);
      // Emit E164 format if available (international format without spaces/symbols)
      const e164Value = phoneObject?.number?.e164 || '';
      // @ts-ignore
      this.$emit('e164', e164Value);
    },
  },
});
